export type PageMeta = {
  title: string;
  description: string;
};

export const COLUMN_INDEX_META: PageMeta = {

  title: "ソフトウェア開発・技術情報コラム｜受託開発のウィソフト",
  description:
    "ウィソフトのコラムでは、ソフトウェア開発やシステム開発、AI技術などに関する情報を発信しています。受託開発で培った知見をもとに、技術動向や開発ノウハウを分かりやすく解説します。開発現場で役立つ実践的な情報をお届けします。",
};

export const PAGE_META_LOCALES: Record<string, Record<string, PageMeta>> = {
  ja: {
    "/": {
      title: "ソフトウェア受託開発・業務システム開発｜ウィソフト株式会社",
      description: "ソフトウェア受託・請負開発ならウィソフト。業務システムやWebシステムなど企業の課題に合わせたソフトウェア開発を提供します。",
    },
    "/service": {
      title: "ソフトウェア受託開発サービス｜ウィソフト株式会社",
      description: "ウィソフトのソフトウェア受託・請負開発サービス。業務システム、Webシステム、各種アプリケーションの設計・開発・運用まで対応。",
    },
    "/company": {
      title: "会社情報｜ソフトウェア受託開発のウィソフト",
      description: "ウィソフトの会社情報ページです。会社概要、企業理念、事業内容などをご紹介。",
    },
    "/development": {
      title: "ソフトウェア開発実績｜受託開発のウィソフト",
      description: "ウィソフトが手がけたソフトウェア受託・請負開発の実績をご紹介。業務システムやWebシステムなどの開発事例を掲載。",
    },
    "/scientific_career": {
      title: "研究事業（AI開発）｜ソフトウェア受託開発のウィソフト",
      description: "ウィソフトの研究事業では、AI（人工知能）や最適化技術などの先端技術の研究開発に取り組んでいます。",
    },
    "/recruit": {
      title: "PM・エンジニア募集｜ソフトウェア受託開発のウィソフト",
      description: "ウィソフトの採用情報。ソフトウェア受託・請負開発を行うエンジニアをはじめ、PMや営業職を募集しています。",
    },
    "/inquiry": {
      title: "開発のご相談・お問い合わせ｜ソフトウェア受託開発のウィソフト",
      description: "ウィソフトへのお問い合わせはこちら。ソフトウェア開発のご相談、受託開発のご依頼などお気軽にお問い合わせください。",
    },
    "/faq": {
      title: "よくある質問｜ソフトウェア受託開発のウィソフト",
      description: "ウィソフトのよくある質問ページです。ソフトウェア受託・請負開発に関するご相談内容や開発の流れなどをまとめています。",
    },
    "/news": {
      title: "新着情報｜ソフトウェア受託開発のウィソフト",
      description: "ウィソフトの新着情報一覧です。",
    },
    "/business": {
      title: "事業内容｜ソフトウェア受託開発のウィソフト",
      description: "ウィソフトの事業内容一覧です。",
    },
  },
  en: {
    "/": {
      title: "Software & Business Systems Engineering | WeSoft Co., Ltd.",
      description: "Custom contract software development from business systems to web applications. End-to-end IT services from planning to maintenance.",
    },
    "/service": {
      title: "Services & Solutions | WeSoft Co., Ltd.",
      description: "Comprehensive software engineering services including business systems, web apps, cloud solutions, and mobile applications.",
    },
    "/company": {
      title: "Company Info | WeSoft Co., Ltd.",
      description: "Company overview, corporate philosophy, leadership message, and history of WeSoft Co., Ltd.",
    },
    "/development": {
      title: "Case Studies & Accomplishments | WeSoft Co., Ltd.",
      description: "Explore our software development portfolio across finance, logistics, energy, AI, and public sector solutions.",
    },
    "/scientific_career": {
      title: "Research & AI Engineering | WeSoft Co., Ltd.",
      description: "Advancing artificial intelligence, deep learning, and optimization algorithms through academic publications and joint research.",
    },
    "/recruit": {
      title: "Careers & Open Positions | WeSoft Co., Ltd.",
      description: "Join WeSoft as a Project Manager, Full-Stack Engineer, or Business Consultant. Explore rewarding tech opportunities.",
    },
    "/inquiry": {
      title: "Contact Us & Project Consultation | WeSoft Co., Ltd.",
      description: "Get in touch with WeSoft for software development inquiries, project quotations, and technical consultation.",
    },
    "/faq": {
      title: "Frequently Asked Questions | WeSoft Co., Ltd.",
      description: "Frequently asked questions regarding our software development services, project timelines, costs, and technology stack.",
    },
    "/news": {
      title: "Company News | WeSoft Co., Ltd.",
      description: "Latest news and updates from WeSoft Co., Ltd.",
    },
    "/business": {
      title: "Business Domains | WeSoft Co., Ltd.",
      description: "Business divisions and capabilities of WeSoft Co., Ltd.",
    },
  },
  zh: {
    "/": {
      title: "软件受托开发·业务系统定制｜WeSoft 株式会社",
      description: "WeSoft 株式会社提供全面的软件与业务系统外包定制开发。涵盖需求分析、架构设计到上线部署的全流程服务。",
    },
    "/service": {
      title: "服务范围与业务体系｜WeSoft 株式会社",
      description: "WeSoft 软件外包与定制服务：涵盖业务系统、Web 应用、移动 App 及云原生解决方案的敏捷与瀑布开发。",
    },
    "/company": {
      title: "企业概况·社长致辞｜WeSoft 株式会社",
      description: "WeSoft 公司信息：介绍公司概要、企业理念、社长致辞、发展沿革及合作伙伴。",
    },
    "/development": {
      title: "开发案例与项目实绩｜WeSoft 株式会社",
      description: "WeSoft 成功案例展示：涵盖报销、财务、HR、AI 优化、新能源及公共会计等领域的开发实绩。",
    },
    "/scientific_career": {
      title: "科研成果与 AI 研究｜WeSoft 株式会社",
      description: "深耕深度学习与人工智能领域，展示 IEEE 权威学术论文及产学研联合研发成果。",
    },
    "/recruit": {
      title: "诚聘英才·招聘信息｜WeSoft 株式会社",
      description: "WeSoft 招聘信息：诚聘 PM 项目经理、Web 工程师、ERP 顾问及销售精英。",
    },
    "/inquiry": {
      title: "联系我们·业务咨询｜WeSoft 株式会社",
      description: "欢迎联系 WeSoft 团队！提供免费系统方案评估、外包项目报价及技术咨询服务。",
    },
    "/faq": {
      title: "常见问题解答 (FAQ)｜WeSoft 株式会社",
      description: "解答关于软件定制外包的常见疑问，涵盖估价流程、开发模式、后期运维及服务保障。",
    },
    "/news": {
      title: "最新动态与新闻｜WeSoft 株式会社",
      description: "WeSoft 株式会社最新公司动态、参展信息与重大事件。",
    },
    "/business": {
      title: "业务板块与阵容｜WeSoft 株式会社",
      description: "WeSoft 株式会社核心业务板块、人才结构与技术阵容。",
    },
  },
};

export const PAGE_META: Record<string, PageMeta> = PAGE_META_LOCALES.ja;

export const NEWS_PAGE_META: PageMeta = PAGE_META_LOCALES.ja["/news"];
export const BUSINESS_PAGE_META: PageMeta = PAGE_META_LOCALES.ja["/business"];

export const COLUMN_CATEGORIES_META: PageMeta = {
  title: `カテゴリ一覧｜${COLUMN_INDEX_META.title}`,
  description: COLUMN_INDEX_META.description,
};

export function articlePageMeta(
  articleTitle: string,
  body: string,
  metaDescription?: string
): PageMeta {
  const explicit = metaDescription?.replace(/\s+/g, " ").trim();
  if (explicit) {
    return {
      title: `${articleTitle}｜${COLUMN_INDEX_META.title}`,
      description: explicit,
    };
  }

  const flat = body.replace(/\s+/g, " ").trim();
  const max = 120;
  const description =
    flat.length === 0
      ? COLUMN_INDEX_META.description
      : flat.length > max
        ? `${flat.slice(0, max)}…`
        : flat;
  return {
    title: `${articleTitle}｜${COLUMN_INDEX_META.title}`,
    description,
  };
}
